import QuillNamespace from 'quill';
import Image from 'quill/formats/image';

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents, @typescript-eslint/no-explicit-any
const Quill = QuillNamespace;
window['Quill'] = Quill;

const ATTRIBUTES = ['alt', 'height', 'width', 'style', 'align'];

/**
 * ImageFormat class for QuillEditor.
 * Created to add the styles from the Editor to the string which is saved in DB.
 * Needed for correct alignment of pictures when using the Align functionality.
 */
export class ImageFormat extends Image {
    /** domNode does not have any type inffered in 'quill/formats/image.js' as well. Using any as in library. */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    domNode: any;

    static formats(domNode): {} {
        return ATTRIBUTES.reduce(function (formats, attribute): {} {
            if (domNode.hasAttribute(attribute)) {
                formats[attribute] = domNode.getAttribute(attribute);
            }
            return formats;
        }, {});
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static value(domNode): any {
        return domNode.getAttribute('src');
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    format(name: string, value: any): void {
        if (ATTRIBUTES.indexOf(name) > -1) {
            if (value) {
                this.domNode.setAttribute(name, value);
            } else {
                this.domNode.removeAttribute(name);
            }
        } else {
            super.format(name, value);
        }
    }
}
